import { render, staticRenderFns } from "./WorldHamochi.vue?vue&type=template&id=bd98f036&scoped=true&"
import script from "./WorldHamochi.vue?vue&type=script&lang=js&"
export * from "./WorldHamochi.vue?vue&type=script&lang=js&"
import style0 from "./WorldHamochi.vue?vue&type=style&index=0&id=bd98f036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd98f036",
  null
  
)

export default component.exports